module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_15-d458bb26d2bb1410717ab092f8455a64.jpg";